module.exports = __webpack_public_path__ + "img/FSIN.062433b9.svg";